import React from 'react';
import ReactDOM from 'react-dom/client';
import {createStore} from 'redux';
import { Provider} from 'react-redux';

import {ScoreBoard} from './score-board.js';
import { tie_init } from './Utility.js';

//page
import App from './App.js';
//import reportWebVitals from './reportWebVitals';

//css
import './index.css';
import './App.css';
import './css/Client.css';
import './css/Pool.css';
import './css/reset.css';
import './css/Title.css';
import './css/TypeSelect.css';
import './css/PredictionTitle.css';
import './css/PredictionBox.css';
import './css/BettingBox.css';
import './css/PredictionText.css';
import './css/Login.css';
import './css/PredictionRecordBox.css';
import './css/RechargePointModal.css';
import './css/TimeTicketBuyModal.css';
import './css/TimeTicketUseModal.css';
import './css/ServiceCenterModal.css';
import './css/DetailModalType1.css';
import './css/DetailModalType2.css';
import './css/WriteModalType.css';


Text.defaultProps = Text.defaultProps || {};
Text.defaultProps.allowFontScaling = false;

function reducer(currentState,action){
  if(currentState===undefined)
    {
      return{
        DisplayType : "D",
        NickName : "",
        Point : 0,
        RemainTime : 0,
        Request : 0,
        Result:[],
        ForPush:[],
        board: null,
        bigRoad: null,
        smallRoad : null,
        record_array:[
          // A
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // B
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // C
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // D
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // E
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // F
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // G
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },


          // H
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // I
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // J
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // K
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // L
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // M
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // N
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // O
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // P
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },     
          // Q
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },    
          // R
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },    
          // S
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },         
        ],
        
        cur_stage : 0,
        recharge_point_modal : false,
        time_ticket_buy_modal : false,
        time_ticket_use_modal : false,
        service_center_modal : false,

        recharge_point_log_array:[],
        time_ticket_buy_log_array:[],

        time_ticket_array:[],
        time_ticket_use_log_array:[],

        notice_data_array:[],
        guide_data_array:[],
        terms_data_array:[],
        faq_data_array:[],
        qa_data_array:[],

        detail_modal_type1_open : false,
        detail_modal_type1_type : 0,
        detail_modal_type1_no : 0,

        detail_modal_type2_open : false,
        detail_modal_type2_no : 0,

        write_modal_open : false,

        qa_refresh : false,

        sel_type : "A",
      }
    }
    const newState = {...currentState};

    if(action.type==='UpdateSelType')
    {
      newState.sel_type = action.SelectType;
    }

    if(action.type==='ChangeDisplayType')
    {
      newState.DisplayType = action.DisplayType;
    }
    
    if(action.type==='UserInfo')
    {
        newState.NickName = action.NickName;
        newState.Point = action.Point;
        newState.RemainTime = action.RemainTime

        newState.Result = [];
        newState.ForPush = [];
        newState.board = null;
        newState.bigRoad  = null;
        newState.smallRoad = null;
        newState.record_array=[
            // A
            {
              total_win_count:0,
              total_fail_count:0,
              continue_win_count:0,
              max_continue_win_count:0,
              continue_fail_count:0,
              max_continue_fail_count:0,
              out_break:false,
              prediction:"",
              exception_view_count:0,
              continue_fail_out_break:false,
              out_break_type:0,
              visual_prediction:"",
              win_fail_count:0,
              fail_win_count:0,
              visual_total_win_count:0,
              visual_total_fail_count:0,
              visual_continue_win_count:0,
              visual_max_continue_win_count:0,
              visual_continue_fail_count:0,
              visual_max_continue_fail_count:0,
            },
            // B
            {
              total_win_count:0,
              total_fail_count:0,
              continue_win_count:0,
              max_continue_win_count:0,
              continue_fail_count:0,
              max_continue_fail_count:0,
              out_break:false,
              prediction:"",
              exception_view_count:0,
              continue_fail_out_break:false,
              out_break_type:0,
              visual_prediction:"",
              win_fail_count:0,
              fail_win_count:0,
              visual_total_win_count:0,
              visual_total_fail_count:0,
              visual_continue_win_count:0,
              visual_max_continue_win_count:0,
              visual_continue_fail_count:0,
              visual_max_continue_fail_count:0,
            },
            // C
            {
              total_win_count:0,
              total_fail_count:0,
              continue_win_count:0,
              max_continue_win_count:0,
              continue_fail_count:0,
              max_continue_fail_count:0,
              out_break:false,
              prediction:"",
              exception_view_count:0,
              continue_fail_out_break:false,
              out_break_type:0,
              visual_prediction:"",
              win_fail_count:0,
              fail_win_count:0,
              visual_total_win_count:0,
              visual_total_fail_count:0,
              visual_continue_win_count:0,
              visual_max_continue_win_count:0,
              visual_continue_fail_count:0,
              visual_max_continue_fail_count:0,
            },
            // D
            {
              total_win_count:0,
              total_fail_count:0,
              continue_win_count:0,
              max_continue_win_count:0,
              continue_fail_count:0,
              max_continue_fail_count:0,
              out_break:false,
              prediction:"",
              exception_view_count:0,
              continue_fail_out_break:false,
              out_break_type:0,
              visual_prediction:"",
              win_fail_count:0,
              fail_win_count:0,
              visual_total_win_count:0,
              visual_total_fail_count:0,
              visual_continue_win_count:0,
              visual_max_continue_win_count:0,
              visual_continue_fail_count:0,
              visual_max_continue_fail_count:0,
            },
            // E
            {
              total_win_count:0,
              total_fail_count:0,
              continue_win_count:0,
              max_continue_win_count:0,
              continue_fail_count:0,
              max_continue_fail_count:0,
              out_break:false,
              prediction:"",
              exception_view_count:0,
              continue_fail_out_break:false,
              out_break_type:0,
              visual_prediction:"",
              win_fail_count:0,
              fail_win_count:0,
              visual_total_win_count:0,
              visual_total_fail_count:0,
              visual_continue_win_count:0,
              visual_max_continue_win_count:0,
              visual_continue_fail_count:0,
              visual_max_continue_fail_count:0,
            },
            // F
            {
              total_win_count:0,
              total_fail_count:0,
              continue_win_count:0,
              max_continue_win_count:0,
              continue_fail_count:0,
              max_continue_fail_count:0,
              out_break:false,
              prediction:"",
              exception_view_count:0,
              continue_fail_out_break:false,
              out_break_type:0,
              visual_prediction:"",
              win_fail_count:0,
              fail_win_count:0,
              visual_total_win_count:0,
              visual_total_fail_count:0,
              visual_continue_win_count:0,
              visual_max_continue_win_count:0,
              visual_continue_fail_count:0,
              visual_max_continue_fail_count:0,
            },
            // G
            {
              total_win_count:0,
              total_fail_count:0,
              continue_win_count:0,
              max_continue_win_count:0,
              continue_fail_count:0,
              max_continue_fail_count:0,
              out_break:false,
              prediction:"",
              exception_view_count:0,
              continue_fail_out_break:false,
              out_break_type:0,
              visual_prediction:"",
              win_fail_count:0,
              fail_win_count:0,
              visual_total_win_count:0,
              visual_total_fail_count:0,
              visual_continue_win_count:0,
              visual_max_continue_win_count:0,
              visual_continue_fail_count:0,
              visual_max_continue_fail_count:0,
            },



          // H
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // I
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // J
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // K
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // L
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // M
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // N
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // O
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // P
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },     
          // Q
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },      
          // R
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },    
          // S
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },                       
        ];
        newState.recharge_point_log_array = [];
        newState.cur_stage = 0;
        newState.time_ticket_buy_log_array = [];
        newState.time_ticket_array = [];
        newState.time_ticket_use_log_array = [];
        
        newState.notice_data_array = [];
        newState.guide_data_array = [];
        newState.terms_data_array = [];
        newState.faq_data_array = [];
        newState.qa_data_array = [];
    }

    if(action.type === 'UpdatePoint')
    {
        newState.Point = action.Point;
    }    
    
    if(action.type === 'Request')
    {
        newState.Request = 1;
    }
    
    if(action.type === 'Response')
    {
      newState.Request = 0;
    }
    
    if(action.type === 'ResetResult')
    {
      newState.Result = [];
      newState.ForPush = [];
      newState.board = null;
      newState.bigRoad  = null;
      newState.smallRoad = null;
      newState.record_array=[
          // A
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // B
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // C
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // D
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // E
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // F
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // G
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },



          // H
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // I
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // J
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // K
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // L
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // M
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // N
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // O
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },
          // P
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },     
          // Q
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },      
          // R
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },    
          // S
          {
            total_win_count:0,
            total_fail_count:0,
            continue_win_count:0,
            max_continue_win_count:0,
            continue_fail_count:0,
            max_continue_fail_count:0,
            out_break:false,
            prediction:"",
            exception_view_count:0,
            continue_fail_out_break:false,
            out_break_type:0,
            visual_prediction:"",
            win_fail_count:0,
            fail_win_count:0,
            visual_total_win_count:0,
            visual_total_fail_count:0,
            visual_continue_win_count:0,
            visual_max_continue_win_count:0,
            visual_continue_fail_count:0,
            visual_max_continue_fail_count:0,
          },                      
      ];
      newState.cur_stage = 0;
    }

    function CalPool(params)
    {
      let total='';
      switch (params) {
        case 'P':
        total+='B'+9;
        break;
        case 'B':
        total+='R'+9;
        break;
        case 'T':
        total+='G'+9;
        break;
        default:
        console.log('index CalPool error');
        break;
      }
      total+='n';
      return total;
    }
    
    if(action.type === 'UpdateResult')
    {
      tie_init();
      newState.Result.push(action.result);

      newState.ForPush = [];
      for (let i = 0; i < newState.Result.length; i++) {
        newState.ForPush.unshift(CalPool(newState.Result[i]));
      }

      newState.board = ScoreBoard.fromRawData(newState.ForPush);
      newState.bigRoad = newState.board.getBigRoad(6,60);
      newState.smallRoad = newState.board.getSmallRoad();
    }

    if(action.type === 'BackResult')
    {
      tie_init();
      newState.Result.pop();

      newState.ForPush = [];
      for (let i = 0; i < newState.Result.length; i++) {
        newState.ForPush.unshift(CalPool(newState.Result[i]));
      }

      newState.board = ScoreBoard.fromRawData(newState.ForPush);
      newState.bigRoad = newState.board.getBigRoad(6,60);
      newState.smallRoad = newState.board.getSmallRoad(6,70);
    }

    if(action.type === 'UpdateRecord')
    {
      newState.record_array = action.record;
      newState.cur_stage = action.stage_count;
      
      var prediction = newState.record_array[1].prediction;

      var failCount = newState.record_array[18].visual_continue_fail_count;
      var prediction_A = newState.record_array[18].visual_prediction;
      
      if(prediction_A === prediction)// && failCount === 1)
      {
        newState.record_array[18].out_break = true;
      }
      else
      {
        newState.record_array[18].out_break = false;  
      }

      var prediction_B = newState.record_array[17].visual_prediction;

      if(prediction_B === prediction)// && failCount === 1)
      {
        newState.record_array[17].out_break = true;
      }
      else
      {
        newState.record_array[17].out_break = false;
      }

    }

    if(action.type === 'UpdateRechargePointModal')
    {
      newState.recharge_point_modal = action.View;
    }

    if(action.type === 'UpdateRechargePointModalLog')
    {
      newState.recharge_point_log_array = action.Log === null ? [] : action.Log;
    }

    if(action.type === 'UpdateTimeTicketBuyModal')
    {
      newState.time_ticket_buy_modal = action.View;
    }

    if(action.type === 'UpdateTimeTicketBuyModalLog')
    {
      newState.time_ticket_buy_log_array = action.Log === null ? [] : action.Log; 
    }

    if(action.type === 'UpdateTimeTicketUseModal')
    {
      newState.time_ticket_use_modal = action.View;
    }     

    if(action.type === 'UpdateServiceCenterModal')
    {
      newState.service_center_modal = action.View;
    }     

    if(action.type === 'UpdateTimeTicketBuyModalInventory')
    {
      newState.time_ticket_array = action.Log === null ? [] : action.Log; 
    }

    if(action.type === 'UpdateTimeTicketBuyModalLog')
    {
      newState.time_ticket_use_log_array = action.Log === null ? [] : action.Log; 
    }

    if(action.type === 'UpdateRemainTime')
    {
      if(action.RemainTime < 0)
      {
        newState.RemainTime = 0;
        return;  
      }
      newState.RemainTime = action.RemainTime;
    }

    if(action.type === 'MinusUpdateRemainTime')
    {
      newState.RemainTime = newState.RemainTime - action.DeltaMilliSecond;
      if(newState.RemainTime <= 0)
      {
        newState.RemainTime = 0;
      }
    }

    if(action.type === 'UpdateNoticeDataArray')
    {
      newState.notice_data_array = action.Log === null ? [] : action.Log; 
    }

    if(action.type === 'UpdateGuideDataArray')
    {
      newState.guide_data_array = action.Log === null ? [] : action.Log; 
    }

    if(action.type === 'UpdateTermsDataArray')
    {
      newState.terms_data_array = action.Log === null ? [] : action.Log; 
    }

    if(action.type === 'UpdateFAQDataArray')
    {
      newState.faq_data_array = action.Log === null ? [] : action.Log; 
    }

    if(action.type === 'UpdateQADataArray')
    {
      newState.qa_data_array = action.Log === null ? [] : action.Log; 
    }

    if(action.type === 'UpdateDetailModalType1')
    {
      newState.detail_modal_type1_open = action.View;
      newState.detail_modal_type1_type = action.Type;
      newState.detail_modal_type1_no = action.No;
    }     

    if(action.type === 'UpdateDetailModalType2')
    {
      newState.detail_modal_type2_open = action.View;
      newState.detail_modal_type2_no = action.No;
    } 

    if(action.type === 'UpdateWriteModal')
    {
      newState.write_modal_open = action.View;
    } 

    if(action.type === 'UpdateQARefresh')
    {
      newState.qa_refresh = action.Refresh;
    }

    return newState;
}

const store = createStore(reducer);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App this={root._internalRoot.containerInfo.style}/>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
